import { checkRLCValue } from '../../helper/dataProcess';
import { _isPowerGND } from './pcbNetsHelper';
import { getPins } from './IbisModelHelper';
import {
  DDR3, DDR3L, DDR4, DDR5, DDR4L, LPDDR4, LPDDR5, ddrDMTypes, _2TModeDDRTypes, no2TModeSignalsReg,
  DDR5_RDIMM, DDR5_SODIMM, DDR5_UDIMM, DDR5_RDIMM_CARD, DDR5_SODIMM_CARD, DDR5_UDIMM_CARD,
  // DDR3_78_pwrPinList, DDR3_78_gndPinList, DDR3_96_pwrPinList, DDR3_96_gndPinList,
  // DDR4_78_pwrPinList, DDR4_78_gndPinList, DDR4_96_pwrPinList, DDR4_96_gndPinList,
  // DDR5_78_pwrPinList, DDR5_78_gndPinList, DDR5_96_pwrPinList, DDR5_96_gndPinList,
  // LPDDR4_200_pwrPinList, LPDDR4_200_gndPinList, LPDDR4_272_pwrPinList, LPDDR4_272_gndPinList,
  // LPDDR4_366_pwrPinList, LPDDR4_366_gndPinList, LPDDR4_432_pwrPinList, LPDDR4_432_gndPinList,
  prbsTypes,
  DIMM_DDR_TYPES,
  RDIMM_TYPES,
  DDR5_RDIMM_X4
} from '../constants';
import { PKG_TOUCHSTONE, PKG_SPICE, TOUCHSTONE_SPICE, TOUCHSTONE } from '../../../constants/libraryConstants';
import { splitComponentName } from '../../helper/splitComponent';
import { getDDRSignalType } from '../../helper/getSignalType';
import { getLayoutComponents, getTypeFromPartName } from "@/services/PCBHelper";
import rankConstructor from '../../helper/rankConstructor';
import { isByte } from '../result/helper/eyediagram/displayHelper';
import { IGNORE } from '../../PCBHelper';
import { getCompTypeByPrefixLib } from '../../Designs/helper';
import { BGA, CAP, DIE, IND, JUMPER, RES } from '../../../constants/componentType';
import { getPinsDiffData } from '../sweep/sweepingHelper';
import { ADSModelConfig, getADSModelConfig, getDefaultDelayValueFormSignal, StimulusPRBSModelConfig } from '../ADS/dataHelper';
import ibisAMIConstructor from '../AMIModelHelper/libraryIbisAmiConstructor';
import auroraDBJson from '../../Designs/auroraDbData';
import { PACKAGE_VERIFICATION, PCB, PCB_CHANNEL, VERIFICATION } from '../../../constants/treeConstants';
import { getModelTypePins, getPinRightDisplay } from '../../helper/packageModelHelper';
import { getSpiceModelList, getTouchstoneParse } from '../library';
import { autoSelectTouchstonePorts } from '../../helper/touchstoneHelper';
import { BasicComponent, CapComponent, Model, RLComponent } from '../../helper/setup/integratedinterface';
import { resetDefaultValue } from '../../helper/numberHelper';

function RockyCtrl() {
  this.pcbId = '';
  this.CompsInfo = null;
}
let ctrl = new RockyCtrl();

export function cleanCtrlInfo() {
  ctrl.pcbId = '';
  ctrl.CompsInfo = null;
}

function getJsonComponentsWithNetList({ netList, pcbId, COMP_PREFIX_LIB }) {
  //filter net list
  const _netList = Array.isArray(netList) ? [...new Set([...netList])] : [];
  let CompsInfo = null;
  if (ctrl.pcbId !== pcbId) {
    CompsInfo = auroraDBJson.getComponents(pcbId)
    ctrl.pcbId = pcbId;
    ctrl.CompsInfo = CompsInfo;
  } else {
    CompsInfo = ctrl.CompsInfo;
  }

  let components = []; // [{pin,name,net,value,type}]
  _netList.forEach(netName => {
    const netInfo = auroraDBJson.getNet(pcbId, netName)
    if (netInfo && netInfo.pins) {
      let list = []

      let keys = Array.from(netInfo.pins.keys());
      for (let comp of keys) {
        const compInfo = CompsInfo.get(comp);
        let _compInfo = compInfo;
        if (!compInfo) {
          _compInfo = {
            type: "Ignore",
            value: "",
            part: "UNKNOW"
          }
        }
        let { type, value, location, name, partName, partNumber } = _compInfo;

        if (!name) {
          continue
        }

        if (type === "Ignore" && name.match(/^MR_?[0-9]+/g)) {
          type = 'Res'
        }

        if (COMP_PREFIX_LIB) {
          //update component type by custom component reference designator
          type = getCompTypeByPrefixLib(comp, COMP_PREFIX_LIB);
        }

        if ([IND, CAP, RES].includes(type) && (compInfo.pins.size > 10 || compInfo.pins.size < 2) && compInfo.pins.size !== 0) {
          type = IGNORE
        }

        if (!COMP_PREFIX_LIB || (COMP_PREFIX_LIB && type === 'Ignore')) {
          const _type = getTypeFromPartName(compInfo.partName)
          if (_type) {
            type = _type
          }
        }

        const pinNameList = netInfo.pins.get(comp);//获取了很多的pin
        for (let pinName of pinNameList) {
          list.push({
            pin: pinName && pinName ? pinName : "",
            name: comp,
            pinName,
            net: netName,
            value: ["Res", "Ind", "Cap"].includes(type) ? value : "",
            type: type,
            part: partName,
            location,
            partName,
            partNumber
          })
        }
      }
      components.push(...list.filter(item => !!item));
    }
  });
  return components;
};

function getJsonComponents(netList, pcbId, COMP_PREFIX_LIB, doNotStuff, specify = []) {
  let Components = [],
    exsitcomponentsName = [],
    findVRMComps = [],
    findCaps = [];
  const _Components = getJsonComponentsWithNetList({ netList, pcbId, COMP_PREFIX_LIB });
  for (const comp of _Components) {
    const { name, pin, net, value, type, part, pinName } = comp;
    const _index = exsitcomponentsName.indexOf(name);
    if ((doNotStuff || []).includes(name)) {
      continue;
    }
    if (_index < 0) {
      // Not exsit component
      let newComp;
      if (type === "Cap") {
        newComp = new CapComponent({
          name,
          usage: type,
          part,
          pins: [{ pin, net, pinName, mName: pinName }],
        });
        newComp.value = { r: "", l: "", c: "", };
        newComp.model = new Model({ type: "", name: "", subcktName: "" });
        findCaps.push({ ...newComp, location: comp.location });
      } else if ([RES, IND, JUMPER].includes(type) || specify.includes(name)) {
        let _value = checkRLCValue(value);
        if (type === RES) {
          //resistor default value to 0 that is smaller than 10 mOhm
          _value = resetDefaultValue(_value);
        }
        newComp = new RLComponent({
          name,
          usage: type,
          part,
          pins: [{ pin, net, pinName, mName: pinName }],
          value: _value,
        });
        findVRMComps.push({ ...newComp, pinList: newComp.pins, location: comp.location });
      } else {
        newComp = new BasicComponent({
          name,
          usage: type,
          part,
          pins: [{ pin, net, pinName, mName: pinName }],
        });
      }
      Components.push(newComp);
      // Update components name list
      exsitcomponentsName.push(name);
    } else {
      // Exsit component
      Components[_index].pins.push({ pin, net, pinName });
    }
  }
  return { Components, findVRMComps, findCaps };
}

export {
  getJsonComponentsWithNetList,
  getJsonComponents
};